// One hand-bumped identifier per deploy of the labs bundle.
//
// WHY THIS EXISTS, and why analysis must split on it rather than on a timestamp:
// CloudFront serves the old bundle to already-warm clients for a while after a deploy, so
// "sessions after 14:06 UTC" is NOT the same set as "sessions running the new code". Any
// before/after comparison across a deploy split on time silently mixes the two. Every trace
// and every funnel event carries this string, so the split can be made exactly.
//
// BUMP THIS ON EVERY DEPLOY that changes labs behaviour or capture. Format: date + suffix.
// NOT bumped for the 2026-10-15 division-arm closure, which is my error: that deploy carries
// the 09-13 stamp, so its traces cannot be split from the preceding month by bundle. The arm
// field itself still identifies the regime (division sessions stop), so the practical loss is
// limited to the cache-tail ambiguity in the first hours.
// '2026-10-16-stoprule' was NEVER DEPLOYED. It was built, QA'd locally, and is carried by the QA
// traces of session 78439f72 against a dev server. Reusing it for the go-live deploy would give
// live forced-arm traces and local QA traces the same stamp, which is the one thing this constant
// exists to prevent, so the live deploy takes a new one.
//
// '2026-10-16-forcedarm-live' DID deploy, carrying the g24 forced arm. It is also carried by the
// rebus QA session fdeef56a, because that walk-through ran against a dev server built from the
// same source and therefore the same stamp. So this constant does NOT separate that QA session
// from live traffic, and it is recorded by session id in PREREG_stoprule_rebus.md section 5
// instead. The lesson, noted here because it will recur: bumping AFTER a local walk-through makes
// the previous stamp a QA marker, but only by luck, and only until the next walk-through reuses
// the new one. A `?qa=1` provenance flag stamped on the trace remains the real fix.
export const LABS_BUILD = '2026-10-16-rebusarm-live'
